import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

class ProfileNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      visibleProfileLinks: false,
    }
  }

  componentDidCatch(error, info) {
    console.log('error - ProfileNav')
    console.log(error)
    console.log('info')
    console.log(info)
  }


  componentDidMount() {
    window.addEventListener('click', () => {
      this.setState({
        visibleProfileLinks: false,
      })
    })
  }

  handleClick(e) {
    e.stopPropagation()
    this.setState({
      visibleProfileLinks: !this.state.visibleProfileLinks,
    })
  }

  render() {
    const { viewer, intl } = this.props
    const { visibleProfileLinks } = this.state

    return (
      <div
        className="profile-nav"
        onClick={e => this.handleClick(e)}
      >
        <img
          alt="Profile"
          className="user-profile-image"
          src={viewer.picture || '/assets/images/placeholder-face-big.png'}
        />
        <span className="user-name">{viewer.firstName}</span>
        <img id="profile-header-menu" className="arrow-down-image" src="/assets/images/arrow-down.png" alt="Arrow down" />
        {
          visibleProfileLinks &&
          <div className="profile-nav-links">
            <nav>
              <Link to="/app/user">
                {intl.formatMessage(messages.profile)}
              </Link>
              <Link id="sign-out-link" to="/sign-out">
                {intl.formatMessage(messages.logOut)}
              </Link>
            </nav>
          </div>
        }
      </div>
    )
  }
}

ProfileNav.propTypes = {
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
}

const enhance = compose(
  withRouter,
  connect(state => ({
    viewer: state.users.viewer,
  }), { }),
  injectIntl,
)

export default enhance(ProfileNav)

const messages = defineMessages({
  profile: {
    id: 'profileNav.profile',
    defaultMessage: 'Profil',
  },
  logOut: {
    id: 'profileNav.logOut',
    defaultMessage: 'Odhlásiť sa',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/ProfileNav.js